import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import removeCallableAssociation from 'calling-global-api/methods/removeCallableAssociation';
import ChickletHoverActionsContainer from '../../chicklets/ChickletHoverActionsContainer';
import ChickletWrapper from '../../chicklets/ChickletWrapper';
import Chicklet from '../../chicklets/Chicklet';
// @ts-expect-error file not migrated yet
import addMutationResultAlert from 'customer-data-sidebar/universal/alertHelpers/addMutationResultAlert';
import ChickletAssociationButtons from '../../chicklets/ChickletAssociationButtons';
// @ts-expect-error file not migrated yet
import { getUserCanView } from 'customer-data-sidebar/universal/permissions/UserPermissions';
import { ChickletPrimaryDisplayLabel } from '../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../extensions/hooks/useBehavior';
import { useAssociatedObjectsCardContentContext } from '../../context/AssociatedObjectsCardContext';
import { useGetSpecificAssociationDefinitions } from '../../hooks/useFetchAllAssociationTypesBetweenObjectIds';
import AssociationChicklet from '../../chicklets/associations/AssociationChicklet';
import { getAvatarProps } from '../../helpers/avatarHelpers';
import ChickletSecondaryProperties from '../secondaryProperties/ChickletSecondaryProperties';
import { getChickletPrimaryDisplayProperties, getSeleniumIdentifier } from './getChickletPrimaryDisplayProperties';
import useDeleteCrmObjectAssociationBySpecMutation from '../../hooks/useDeleteCrmObjectAssociationBySpecMutation';
import { DISPLAY_LABEL_FALLBACK } from '../../constants/displayLabelFallback';
import Raven from 'raven-js';
import { useGetIsArtificialIntelligenceAssociation } from '../../hooks/useGetIsArtificialIntelligenceAssociation';
import { jsx as _jsx } from "react/jsx-runtime";
const Association = ({
  ariaLabel,
  associatedObjectsIds,
  fromObjectId,
  fromObjectTypeId,
  isPrimary = false,
  object,
  objectTypeId,
  onPreview,
  primaryAssociationObjectInfo = {}
}) => {
  const {
    allAssociationTypesBetweenObjectIdsData,
    associationTypesData,
    hasScope,
    isUngated,
    updateQuery,
    onAssociationUpdate
  } = useAssociatedObjectsCardContentContext();
  const {
    associationTypes
  } = associationTypesData;
  const objectId = object.id;
  const canView = getUserCanView(object.userPermissions);
  const {
    primaryDisplayIdentifier,
    secondaryDisplayIdentifier
  } = getChickletPrimaryDisplayProperties(objectTypeId, object, object.properties);
  const specificAssociationDefinitions = useGetSpecificAssociationDefinitions({
    allAssociationTypesBetweenObjectIdsData,
    associationTypes,
    objectId
  });
  const onRemoveAssociationSuccess = () => {
    const removedObjectLabel = primaryDisplayIdentifier || secondaryDisplayIdentifier || DISPLAY_LABEL_FALLBACK;
    addMutationResultAlert({
      messageKey: 'cardAssociatedObjects.alertHelpers.addMutationResultAlert.removeAssociationMutationSucceeded',
      messageKeyOptions: {
        removedObjectLabel
      }
    });
    if (objectTypeId === COMPANY_TYPE_ID) {
      removeCallableAssociation({
        objectTypeId: fromObjectTypeId,
        objectId: `${fromObjectId}`,
        associationObjectId: `${objectId}`,
        associationObjectTypeId: objectTypeId
      }).catch(e => {
        Raven.captureException(e);
      });
    }
  };
  const handleRemoveAssociation = useDeleteCrmObjectAssociationBySpecMutation({
    fromObjectId,
    fromObjectType: fromObjectTypeId,
    toObjectId: objectId,
    toObjectType: objectTypeId,
    toObjectIsPrimary: isPrimary,
    associationSpecs: specificAssociationDefinitions.map(associationDefinition => ({
      associationTypeId: associationDefinition.associationTypeId,
      associationCategory: associationDefinition.associationCategory
    })),
    onSuccess: onRemoveAssociationSuccess,
    onError: () => addMutationResultAlert({
      mutationFailed: true
    }),
    updateQuery,
    onAssociationUpdate
  });
  const ChickletPrimaryDisplayLabelComponent = useBehavior(ChickletPrimaryDisplayLabel, objectTypeId, hasScope, isUngated);
  const seleniumIdentifier = getSeleniumIdentifier(objectTypeId);
  const isAiAssociation = useGetIsArtificialIntelligenceAssociation({
    toObjectId: objectId
  });
  return /*#__PURE__*/_jsx(ChickletWrapper, {
    seleniumId: objectId,
    seleniumIdentifier: seleniumIdentifier,
    ariaLabel: ariaLabel,
    children: /*#__PURE__*/_jsx(ChickletHoverActionsContainer, {
      associationDefinitions: specificAssociationDefinitions,
      associatedObjectsIds: associatedObjectsIds,
      fromObjectId: fromObjectId,
      fromObjectTypeId: fromObjectTypeId,
      objectTypeId: objectTypeId,
      objectId: objectId,
      canView: canView,
      onPreview: onPreview,
      onRemoveAssociation: handleRemoveAssociation,
      primaryAssociationObjectInfo: primaryAssociationObjectInfo,
      toObjectLabel: primaryDisplayIdentifier || secondaryDisplayIdentifier || DISPLAY_LABEL_FALLBACK,
      Buttons: ChickletAssociationButtons,
      children: /*#__PURE__*/_jsx(Chicklet, {
        primaryTagSpacing: isPrimary,
        children: /*#__PURE__*/_jsx(AssociationChicklet, {
          associationDefinitions: specificAssociationDefinitions,
          avatarProps: getAvatarProps({
            objectTypeId,
            objectId
          }),
          isPrimary: isPrimary,
          primaryIdentifier: /*#__PURE__*/_jsx(ChickletPrimaryDisplayLabelComponent, {
            isAiAssociation: isAiAssociation,
            toObjectId: objectId,
            toObjectTypeId: objectTypeId,
            primaryDisplayProperty: object.primaryDisplayProperty,
            canView: canView,
            properties: object.properties,
            onPreview: onPreview
          }),
          children: /*#__PURE__*/_jsx(ChickletSecondaryProperties, {
            object: object,
            objectTypeId: objectTypeId,
            properties: object.properties
          })
        })
      })
    })
  });
};
export default Association;